"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indicatorSchema = void 0;
exports.indicatorSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        claimProcessingUnitTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be an string or null',
        },
        claimReceivedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            format: 'date',
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        eddFemsiFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        editsAndAllowancesFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        enhancedAcppFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        gvsPviiFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        notepadCommentFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        paymentCount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        rffiFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        underwritingInformationReceivedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        underwritingInformationRequestedDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        underwritingReviewEndDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        underwritingReviewFlag: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be among true, false or null',
        },
        underwritingReviewStartDate: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
    },
};
